import { createDraftSafeSelector } from '@reduxjs/toolkit';
import { RootState } from '../Store';

const selectedReducer = (state: RootState) => state.mfilesConfig;

// this is selector for mfiles config
export const selectMFilesConfig = createDraftSafeSelector(
  selectedReducer,
  (mfilesConfigState) => mfilesConfigState.data
);
